import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import _ from "lodash";
import TitleBar from "../_common/TitleBar";
//import Table from "../_common/Table";
import { 
  DataGrid,
  GridToolbarContainer,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
  useGridApiContext,
  gridFilteredSortedRowIdsSelector,
  gridVisibleColumnFieldsSelector, 
} from "@mui/x-data-grid";
import MenuItem from '@mui/material/MenuItem'
import { actionScripts } from "../../_helpers/actionScripts";

const getJson = (apiRef) => {
  // Select rows and columns
  const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
  const visibleColumnsField = gridVisibleColumnFieldsSelector(apiRef);

  // Format the data. Here we only keep the value
  const data = filteredSortedRowIds.map((id) => {
    const row = {};
    visibleColumnsField.forEach((field) => {
      row[field] = apiRef.current.getCellParams(id, field).value;
    });
    return row;
  });

  // Stringify with some indentation
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#parameters
  return JSON.stringify(data, null, 2);
};

const exportBlob = (blob, filename) => {
  // Save the blob in a json file
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();

  setTimeout(() => {
    URL.revokeObjectURL(url);
  });
};

function JsonExportMenuItem(props) {
  const apiRef = useGridApiContext();

  const { hideMenu } = props;

  return (
    <MenuItem
      onClick={() => {
        const jsonString = getJson(apiRef);
        const blob = new Blob([jsonString], {
          type: 'text/json',
        });
        exportBlob(blob, 'data.json');

        // Hide the export menu after the export
        //hideMenu?.();
      }}
    >
      Export JSON
    </MenuItem>
  );
}

JsonExportMenuItem.propTypes = {
  hideMenu: PropTypes.func,
};

const csvOptions = { delimiter: ',' };

function CustomExportButton(props) {
  return (
    <GridToolbarExportContainer {...props}>
      <GridCsvExportMenuItem options={csvOptions} />
      <JsonExportMenuItem />
    </GridToolbarExportContainer>
  );
}

function CustomToolbar(props) {
  return (
    <GridToolbarContainer {...props}>
      <CustomExportButton />
    </GridToolbarContainer>
  );
}

class LaborWeeklyReport extends Component {
  state = {
    sortColumn: { path: "laborFullName", order: "asc" },
  };

  // columns = [
  //   { label: "Name", path: "laborFullName", showTotalsLabel: true },
  //   { label: "Trade", path: "trade" },
  //   { label: "Contractor", path: "contractorName" },
  //   { label: "Week Ending", path: "weekEnding" },
  //   { label: "Hours Worked", path: "hoursWorked", showTotals: true }
  // ];

  dataGridColumns = [
    {
      field: "id",
      headerName: "ID",
      hide: true,
      disableExport: true
    },
    {
      field: "laborFullName",
      headerName: "Name",
      width: 150
    },
    {
      field: "trade",
      headerName: "Trade",
      width: 150
    },
    {
      field: "contractorName",
      headerName: "Contractor",
      width: 150
    },
    {
      field: "weekEnding",
      headerName: "Week Ending",
      width: 150
    },
    {
      field: "regularHoursWorked",
      headerName: "Regular Hours Worked",
      width: 150
    },
    {
      field: "overtimeHoursWorked",
      headerName: "Overtime Hours Worked",
      width: 150
    },
    {
      field: "hoursWorked",
      headerName: "Total Hours Worked",
      width: 150
    },
    {
      field: "isVerified",
      headerName: "Labor Verification Status",
      width: 150,
      renderCell: (params) => 
        params.row.isVerified 
        ? <span className="badge badge-success p-1">Verified</span>
        : <span className="badge badge-secondary p-1">Pending</span>
    }
  ];

  getData = () => {
    const { sortColumn } = this.state;
    const { report } = this.props;
    return _.orderBy(
      report.laborWeeklyReportData,
      [sortColumn.path],
      [sortColumn.order]
    );
  };

  handleClick_tr = (adr, targetId) => {
    if (targetId !== "isTotalsRow") {
      const { tab } = this.props;
      actionScripts.FETCH_ADR.run(tab.projectId, adr.assistantDailyReportId);
    }
  };

  render() {
    const { report } = this.props;
    const data = report.laborWeeklyReportData ? this.getData() : [];
    return (
      <React.Fragment>
        <TitleBar titleText={"Labor Weekly Report"} />
        <div className="card mx-2">
          <div className="card-body">
            <h3>Labor Weekly Report</h3>
            <div className="form-row form-group">
              <label className="col-sm-3 col-form-label">Report Created:</label>
              <div className="col-sm-3">
                <input
                  type="text"
                  disabled
                  className="form-control"
                  value={report.created}
                />
              </div>
            </div>
            <div className="form-row form-group">
              <label className="col-sm-3 col-form-label">Report Remarks:</label>
              <div className="col-sm-5">
                <textarea className="form-control" rows={3} />
              </div>
            </div>
            {/* <Table
              className="table table-hover"
              columns={this.columns}
              data={data}
              idPropName={"laborId"}
              sortColumn={this.state.sortColumn}
              onSort={this.handleSort}
              handleClick_tr={this.handleClick_tr}
            /> */}
            <div style={{ height: 500, width: '100%' }}>
              <DataGrid
                className="table table-hover"
                rows={data}
                columns={this.dataGridColumns}
                pageSize={15}
                rowsPerPageOptions={[15]}
                disableSelectionOnClick={true}
                components={{ Toolbar: CustomToolbar }}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  report: state.reports.openReports[ownProps.tab.tabId],
});

export default connect(mapStateToProps)(LaborWeeklyReport);
